var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.26963 1.08202C7.74567 0.696945 11.2536 0.696945 14.7296 1.08202C16.6286 1.29402 18.1596 2.78902 18.3826 4.69502C18.7946 8.21969 18.7946 11.7803 18.3826 15.305C18.1596 17.211 16.6286 18.706 14.7306 18.919C11.2543 19.3042 7.746 19.3042 4.26963 18.919C2.37063 18.706 0.839631 17.211 0.616631 15.306C0.204613 11.781 0.204613 8.22002 0.616631 4.69502C0.839631 2.78902 2.37063 1.29402 4.26963 1.08202ZM14.4996 4.00002C14.2344 4.00002 13.9801 4.10537 13.7925 4.29291C13.605 4.48045 13.4996 4.7348 13.4996 5.00002C13.4996 5.26523 13.605 5.51959 13.7925 5.70712C13.9801 5.89466 14.2344 6.00002 14.4996 6.00002C14.7648 6.00002 15.0192 5.89466 15.2067 5.70712C15.3943 5.51959 15.4996 5.26523 15.4996 5.00002C15.4996 4.7348 15.3943 4.48045 15.2067 4.29291C15.0192 4.10537 14.7648 4.00002 14.4996 4.00002ZM4.74963 10C4.74963 8.74024 5.25008 7.53206 6.14087 6.64126C7.03167 5.75046 8.23985 5.25002 9.49963 5.25002C10.7594 5.25002 11.9676 5.75046 12.8584 6.64126C13.7492 7.53206 14.2496 8.74024 14.2496 10C14.2496 11.2598 13.7492 12.468 12.8584 13.3588C11.9676 14.2496 10.7594 14.75 9.49963 14.75C8.23985 14.75 7.03167 14.2496 6.14087 13.3588C5.25008 12.468 4.74963 11.2598 4.74963 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.972d1895db137c584867fbd7b6e64ac3.svg";
export { ForwardRef as ReactComponent };